const handleDatePickerErrorMessage = {
  sendToMaintenanceDateError: 'Selecione uma data após a data de Envio',
  returnFromMaintenanceDateError: 'Selecione uma data após a data de Retorno',
};

export default handleDatePickerErrorMessage;